import { ServiceCodeBySystem, IntegrationSystem } from '@/shared/types';

import { config } from '@/config/index';

import { RouteConfig } from '@/router/types';

export const RMPC_ROUTES: Record<keyof ServiceCodeBySystem<IntegrationSystem.RMPC>, RouteConfig> = {
  TATTOO_SEARCH: { basePath: config.router.servicePath, path: 'tattoo-search', isPrivate: false },
};
